import { useState, useEffect, useReducer } from "react";
import { Button, Card, Col, Row } from "reactstrap";
import DataGrid from "../../components/dataGrid/DataGrid";
import { Link, useLocation, useNavigate } from "react-router-dom";
import QueryString from "qs";
// import moment from "moment";
// import { Edit } from "react-feather";

import { getDispatches, DispatchData } from "../../services/dispatch.service";

import { Printer } from "react-feather";
// import toast from "react-hot-toast";
import FormInput from "../../components/FormInput";
import moment from "moment";
// import { exportExcelParty } from "../../services/parties.service";

const initialState = {
  data: [],
  page: 1,
  limit: 10,
  totalPages: 1,
  totalResults: 0,
  startIndex: 1,
  endIndex: 10,
};

function reducer(state: any, action: any) {
  switch (action.type) {
    case "SET_DATA":
      return action.payload;
    default:
      return state;
  }
}

const columns = [
  {
    selector: (row: DispatchData) => row.serialNumber,
    name: "S.No.",
    sortable: false,
    //   wrap: true,
    maxWidth: "70px",
    minWidth: "70px",
  },

  {
    selector: (row: DispatchData) => moment(row.dispatchDate).format("DD-MM-YYYY"),
    name: "Dispatch Date",
    sortable: false,
    wrap: true,
  },
  {
    selector: (row: DispatchData) => row.driverName,
    name: "Driver Name",
    sortable: false,
    wrap: true,
  },

  {
    selector: (row: DispatchData) => row.vehicleNumber,
    name: "Vehicle Number",
    sortable: false,
    wrap: true,
  },
  {
    selector: (row: DispatchData) => row.totalParty,
    name: "Total Party",
    sortable: false,
    wrap: true,
  },

  {
    selector: (row: DispatchData) => row.totalPicklist,
    name: "Total Picklist",
    sortable: false,
    wrap: true,
  },

  {
    selector: (row: DispatchData) => row.totalInvoice,
    name: "Total Invoice",
    sortable: false,
    wrap: true,
  },
  {
    selector: (row: DispatchData) => row.invoiceAmount,
    name: "Invoice Amount",
    sortable: false,
    wrap: true,
  },
  {
    selector: (row: DispatchData) => row.grNumber,
    name: "Route",
    sortable: false,
    wrap: true,
  },

  {
    selector: (row: any) => (
      <>
        <Link className='me-1' to={`print/${row.id}`} target='_blank'>
          <Printer size={15} />
        </Link>
      </>
    ),
    name: "Actions",
    sortable: false,
    center: true,
    maxWidth: "90px",
    minWidth: "90px",
  },
];

function DispatchReports() {
  const [filterData, setFilterData] = useState({
    driverName: "",
    vehicleNumber: "",
    dispatchDate: "",
  });
  const [data, dispatch] = useReducer(reducer, initialState);
  const location = useLocation();
  const navigate = useNavigate();
  const query = QueryString.parse(location.search, { ignoreQueryPrefix: true });

  const setData = (data: any) => {
    dispatch({ type: "SET_DATA", payload: data });
  };
  useEffect(() => {
    const { page, driverName, vehicleNumber, dispatchDate } = query;
    getDispatches({ page, driverName, vehicleNumber, dispatchDate })
      .then((response: any) => {
        setData(response.data);
      })
      .catch(() => {});
  }, [location.search]);

  const handleFilter = () => {
    const queryParams: any = { ...query, page: 1, ...filterData };

    Object.keys(queryParams).forEach((key) => {
      if (!queryParams[key]) {
        delete queryParams[key];
      }
    });

    const queryString = QueryString.stringify(queryParams);
    navigate(`${location.pathname}${Object.keys(queryParams).length > 0 ? "?" + queryString : ""}`);
  };
  const handleClearFilter = () => {
    setFilterData({ driverName: "", vehicleNumber: "", dispatchDate: "" });
    const queryParams = { page: 1 };
    const queryString = QueryString.stringify(queryParams);
    navigate(`${location.pathname}?${queryString}`);
  };

  return (
    <div className='d-flex flex-column h-100 px-sm-1 w-100 pb-sm-1'>
      <Row className='align-items-center mb-2'>
        <Col sm>
          <h1 className='my-1 fw-bold h4'>Dispatch Report</h1>
        </Col>
      </Row>

      <div className='flex-grow-1 overflow-auto'>
        <Card className='h-100 p-3 w-100 '>
          <div className='d-flex flex-column h-100 rounded-0'>
            <DataGrid
              columns={columns}
              data={data}
              filterByDate={true}
              FilterSubHeader={true}
              filterData={filterData}
              setFilterData={setFilterData}
              subHeaderComponent={
                <Row>
                  <Col md={2}>
                    <FormInput
                      name='driverName'
                      label='Driver Name'
                      placeholder='Driver Name'
                      onChange={(e) =>
                        setFilterData({
                          ...filterData,
                          [e.target.name]: e.target.value,
                        })
                      }
                      value={filterData.driverName}
                    />
                  </Col>
                  <Col md={2}>
                    <FormInput
                      name='vehicleNumber'
                      label='Vehicle Number'
                      placeholder='Vehicle Number'
                      onChange={(e) =>
                        setFilterData({
                          ...filterData,
                          [e.target.name]: e.target.value,
                        })
                      }
                      value={filterData.vehicleNumber}
                    />
                  </Col>
                  <Col md={2}>
                    <FormInput
                      name='dispatchDate'
                      label='Dispatch Date'
                      placeholder='Dispatch Date'
                      type='date'
                      onChange={(e) =>
                        setFilterData({
                          ...filterData,
                          [e.target.name]: e.target.value,
                        })
                      }
                      value={filterData.dispatchDate}
                    />
                  </Col>

                  <Col md={2} className='mt-1'>
                    <div className='mt-4'>
                      <Button
                        color='primary'
                        size='sm'
                        className='me-2'
                        onClick={() => handleFilter()}
                      >
                        Filter
                      </Button>
                      <Button
                        color='danger'
                        size='sm'
                        className='me-2'
                        onClick={() => handleClearFilter()}
                      >
                        Clear
                      </Button>
                    </div>
                  </Col>
                  <Col md={2}></Col>
                  {/* <Col md={2} className='mt-1'>
                    <div className='mt-4 text-end'>
                      <Button
                        color='primary'
                        size='sm'
                        onClick={() => {
                          exportExcelParty()
                            .then((response) => {
                              const blobURL = URL.createObjectURL(response.data);
                              const anchor = document.createElement("a");
                              anchor.href = blobURL;
                              anchor.download = "Party Master.xlsx";
                              anchor.click();
                              URL.revokeObjectURL(blobURL);
                            })
                            .catch(() => {
                              toast.error("Record not found to export.");
                            });
                        }}
                      >
                        Export
                      </Button>
                    </div>
                  </Col> */}
                </Row>
              }
            />
          </div>
        </Card>
      </div>
    </div>
  );
}

export default DispatchReports;
